import { useSelector } from 'react-redux';
import { RootState } from '../store/rootReducer';

const useStateSelector = <TSelected>(selector: (state: RootState) => TSelected, equalityFn?: (left: TSelected, right: TSelected) => boolean): TSelected => {
  return useSelector(selector, equalityFn);
};

export default useStateSelector;
